import { useDispatch, useSelector } from "react-redux";
import { useState, useMemo, useRef } from "react";
import { VerticalHelpOrTip } from "../components/HelpOrTip";
import * as theme from "../theme";
import QFNavigation from "./QFNavigation";
import QuestionArea from "./QuestionArea";
import Button from "@material-ui/core/Button";
import InfoIcon from "@material-ui/icons/Info";
import { toast } from "react-toastify";
import {
  getClientLog,
  getProspectDoc,
  submitChangesForClient,
  submitConsentForClient,
} from "../store/qf";
import { editCustomerById } from "../store/mycustomers"
import { createRemider } from "../store/myreminder";
import { addTransaction } from "../store/transactions";
import { loadBrokerageInsurers, loadProspectInsurers } from "../store/insurers";
import { useNavigate } from "react-router-dom";
import { CommonModal } from "../components/CommonModal";
import { GtmModal, ChsSignoffModal, ChsModal } from "../components/Modals";
import { getBrokerageInformation, getDetails } from "../store/brokerage";
import {
  getBrokerInformation,
  retrieveBrokerageImg,
  retrieveBrokerforClient,
} from "../store/broker";
import {
  currentNodeChangeOnNextClick,
  currentNodeChangeOnPreviousClick,
  updateProspectForms,
  updateBmsInfo,
  getIsProspectUpdating,
  getIsProspectSucceed,
  getFormState,
  getFormsOrder,
  getPermanentCodeDetailsFromDoc,
  updatePermanentCodeDetails,
  getCHS,
  updateProspectFormsForClient,
  updateTrackingQAnsweredFinalValues,
  getCurrentNode,
  getCurrentNodeFormId,
  getProspectIdFromQF,
  getIsBpSuccess,
  getopenCHSconfirmationModal,
  openCHSconfirmationModalFun,
  getBMSPayload,
  getProspectFailedResponse,
  initiateCustomerById
} from "../store/qf";
import {
  appendtoProspectOrder,
  getProspectaddedProspectOrder,
} from "../store/myquotes";
import CloudDoneIcon from "@material-ui/icons/CloudDone";
import Spinner from "react-bootstrap/Spinner";
import { useEffect, useLayoutEffect } from "react";
import { findNodeWithThisPermanentCode } from "../store/permanentQues";
import Modal from "react-modal";
import {
  clientHandOffModalClosed,
  getClientHandOffModalState,
  getQFuserMode,
  setautoreminder,
  goToMarket,
} from "../store/components";
import { getRowDetailsFromCustomerId } from '../store/mycustomers'
import CancelIcon from "@material-ui/icons/Cancel";
import { Form, InputGroup, Col, Row } from "react-bootstrap";
import LinkSelect from "./LinkSelect";
import {
  BROKER,
  CLIENT,
  FormProperties,
} from "../store/businesslogic/hardwiredlogic";
import {
  Client_Business_name,
  Client_Contact,
  Client_Email,
  Client_Name,
} from "../store/permanentQues";
import SaveAndProceedButton from "./SaveAndProceedButton";
import debounce from "lodash.debounce";
import {
  Typography,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  makeStyles,
} from "@material-ui/core";
import translations from "../utils/translations";

const QFMainPane = () => {
  const formstate = useSelector(getFormState);
  const formsorder = useSelector(getFormsOrder);
  const clientHandOffModalOpen = useSelector(getClientHandOffModalState);
  const permanentcodedetails = useSelector(getPermanentCodeDetailsFromDoc);
  const showConfirmationModal = useSelector(getopenCHSconfirmationModal);
  const prospectFailedResponse = useSelector(getProspectFailedResponse);
  const gotProspectDetails = useSelector(getProspectDoc);
   const customerDetails = useSelector(getRowDetailsFromCustomerId({ customerid: gotProspectDetails?.otherdetails?.customerid })) || {} ;
  let client_name_node = useRef(null);
  const prospectId = useSelector(getProspectIdFromQF);
  let popupHeight = 50;
  let popupWidth = 30;
  const history = useNavigate();
  const dispatch = useDispatch();
  //dispatch(getDetails())
  const [disableSbmtBtn, setdisableSbmtBtn] = useState(true);
  const [openModal, setopenModal] = useState(false);
  const [creditQDis, setcreditQDis] = useState("none");
  const [iconArr, setIconArr] = useState([false, false, false]);
  const [cbArr, setCbArr] = useState([false, false, false, null, null]);
  const brokerage_info = useSelector(getBrokerageInformation);
  const broker_info = useSelector(getBrokerInformation);
  const prevValues = useRef({ '10501': null, '10507': null });
  const clientHandOffAgreeTextTranslations =
    translations[broker_info.information.languagepreference]
      .clientHandOffAgreeText;
  const freshProspectinOrder = useSelector(getProspectaddedProspectOrder);
  useLayoutEffect(() => {
    const requiredKeys = [
      Client_Business_name,
      Client_Contact,
      Client_Email,
      Client_Name,
    ];
    const hasAllRequiredKeys =
      permanentcodedetails &&
      requiredKeys.every((key) => key in permanentcodedetails);
    if (!permanentcodedetails || !hasAllRequiredKeys) {
      // call the api
      dispatch(updatePermanentCodeDetails());
    }
  }, [permanentcodedetails, dispatch]);

  useEffect(() => {
    setopenModal(showConfirmationModal);
  }, [showConfirmationModal]);

  useEffect(() => {
    if(prospectFailedResponse && prospectFailedResponse.name == 'TokenExpiredError'){
      history(`/login`)
    }
  }, [prospectFailedResponse])

  useEffect(() => {
    if (cbArr[0] && cbArr[2] && cbArr[3]) {
      setdisableSbmtBtn(false);
    } else {
      setdisableSbmtBtn(true);
    }
  }, [cbArr]);

  useEffect(() => {
    let credit_answer = formstate?.a?.nodestate?.["11106"]?.answer;
    if (credit_answer == "Yes") {
      setcreditQDis("flex");
    } else {
      setcreditQDis("none");
      updateIconArr(1, false);
    }
  }, [formstate?.a?.nodestate?.["11106"]]);

  useEffect(() => {
    dispatch(getDetails());
  }, [dispatch]);

  useEffect(() => {
    if(prospectId)
      dispatch(loadProspectInsurers(prospectId));
  }, [prospectId]);

  useEffect(() => {
    let newProspectInformation = Object.values(formstate?.a?.nodestate).filter(
      (x) => x.permanentcode
    );
    if (
      !freshProspectinOrder &&
      newProspectInformation.every((obj) => !!obj.answer)
    ) {
      let newObj = newProspectInformation.reduce(
        (acc, def) => ({
          ...acc,
          [def.permanentcode]: def.answer,
        }),
        {
          prospectid: prospectId,
          calculatedverticalid: 1,
          selectedverticalid: 1,
          clientdetails: "notstarted",
          brokeragecode: broker_info?.information?.brokeragecode,
          brokername: broker_info?.information?.user?.name,
          vertical: {
            en: "Contractor",
            fr: "Entrepreneur",
          },
          status: "App In Progress",
        }
      );
      dispatch(appendtoProspectOrder(newObj));
    }
  }, [formstate, dispatch]);

  useEffect(() => {
    dispatch(getDetails());
  }, [dispatch]);

  // useEffect(() => {
  //   //console.log(brokerage_info)
  //   dispatch(loadBrokerageInsurers(brokerage_info.code));
  // }, [brokerage_info]);

  useEffect(() => {
    let newProspectInformation = Object.values(formstate?.a?.nodestate).filter(
      (x) => x.permanentcode
    );
    if (
      !freshProspectinOrder &&
      newProspectInformation.every((obj) => !!obj.answer)
    ) {
      let newObj = newProspectInformation.reduce(
        (acc, def) => ({
          ...acc,
          [def.permanentcode]: def.answer,
        }),
        {
          prospectid: prospectId,
          calculatedverticalid: 1,
          selectedverticalid: 1,
          clientdetails: "notstarted",
          brokeragecode: broker_info?.information?.brokeragecode,
          brokername: broker_info?.information?.user?.name,
          vertical: {
            en: "Contractor",
            fr: "Entrepreneur",
          },
          status: "App In Progress",
        }
      );
      dispatch(appendtoProspectOrder(newObj));
    }
  }, [formstate, dispatch]);

  useEffect(() => {
    if(gotProspectDetails?.otherdetails?.addclientinfo){
      //check if a value is null
      
      let requiredKeys = ['10101'];
      let company = null;
      for (const field of requiredKeys) {
        const value = formstate?.a?.nodestate?.[field]?.answer;
        if (value === null || value === undefined || value === '') {
          console.error("Add client info is needed but returning early ", field)
          return;
        }
      }
      let companykeys = ['10507', '10501'];
      for (const field of companykeys) {
        const value = formstate?.a?.nodestate?.[field]?.answer;
        if (value === null || value === undefined || value === '') {
          continue
        }
        company = value;
      }

      if(!company){
        console.log("Missing company infor");
        return
      }

      let payload = {
        customerid : gotProspectDetails?.otherdetails?.customerid,
        contacts: [
          {
            name: formstate.a.nodestate['10101'].answer,
            phone: formstate.a.nodestate['10102'].answer,
            email:formstate.a.nodestate['10103'].answer,
          }
        ],
        company,
        address: formstate.a.nodestate['10505'].answer
      }
      dispatch(initiateCustomerById(payload))
    }
  }, [formstate, dispatch])

  useEffect(() => {
      const updateCustomerInfo = (nodeId) => {
        const company = formstate.a.nodestate[nodeId]?.answer;
        const key = 'companyinfo';
        const customerid = gotProspectDetails?.otherdetails?.customerid;
        if (!customerid || company === undefined) {
          // console.warn(`Skipping update for node ${nodeId}: missing customerid or company`);
          return;
        }
        // Only dispatch if the company value has changed and customerid exists
        if (customerid && company !== prevValues.current[nodeId]) {
          // console.log(`DISPATCHED for node ${nodeId}: `, customerid, company);
          dispatch(editCustomerById({ customerid, key, data: { company } }));
          prevValues.current[nodeId] = company; // Update the previous value
        }
      };
      // Call the function for both node IDs
      updateCustomerInfo('10501');
      updateCustomerInfo('10507');
      // Cleanup to update prevValues on unmount (optional, for completeness)
      return () => {
          prevValues.current['10501'] = null;
          prevValues.current['10507'] = null;
      };
  }, [formstate.a.nodestate['10501']?.answer, formstate.a.nodestate['10507']?.answer, gotProspectDetails?.otherdetails?.customerid]);

  useEffect(() => {
    let website = formstate.a.nodestate['10503']?.answer;
    const customerid = gotProspectDetails?.otherdetails?.customerid;
    //console.log("WEBSITE: ", website)
    dispatch(editCustomerById({ customerid, key:'companyinfo', data: { website } }));
  },[formstate.a.nodestate['10503']?.answer])

  useEffect(() => {
    let address = formstate.a.nodestate['10505']?.answer;
    const customerid = gotProspectDetails?.otherdetails?.customerid;
    //console.log("WEBSITE: ", website)
    dispatch(editCustomerById({ customerid, key:'companyinfo', data: { address } }));
  },[formstate.a.nodestate['10505']?.answer])


  useEffect(() => {
    let contact =  {
      name: formstate.a.nodestate['10101'].answer,
      phone: formstate.a.nodestate['10102'].answer,
      email:formstate.a.nodestate['10103'].answer,
    }
    //console.log("customerDetails ", customerDetails)
    //get actual obj 
    let customerDetails_ = {contacts:[]};
    let contactInfoIndex = 0;
    const newContacts = [...(customerDetails_.contacts || [])];
    newContacts[contactInfoIndex] = contact;
    let uploadData = newContacts;
    const customerid = gotProspectDetails?.otherdetails?.customerid;
    //console.log("USE EFFECT email");
    //console.log(uploadData)
    //console.log("WEBSITE: ", website)
    dispatch(editCustomerById({ customerid, key:'contacts', data: uploadData  }));
  },[formstate.a.nodestate['10103']?.answer, formstate.a.nodestate['10102']?.answer])

  const showThankyouPage = () => {
    try {
      if (broker_info?.brokerageImg.website) {
        window.location = "http://" + broker_info?.brokerageImg.website;
        //window.open( 'http://'+broker_info?.brokerageImg.website, '_blank');
      } else history(`/thanksforanswers`);
    } catch (e) {
      return false;
    }
  };

  const updateIconArr = (index, bool = true) => {
    const arr = [...iconArr];
    arr[index] = bool;
    setIconArr(arr);
  };
  const updateCBArr = (index, state) => {
    const arr = [...cbArr];
    arr[index] = state;
    setCbArr((prevArr) => {
      const arr = [...prevArr];
      arr[index] = state;
      return arr;
    });
  };
  const onSignatureChange = useMemo(
    () =>
      debounce((param, _event) => {
        updateCBArr(param, _event.target.value);
      }, 500),
    []
  );
  let credit_answer = formstate?.a?.nodestate?.["11106"]?.answer;
  // if(credit_answer == "Yes"){
  //   setcreditQDis("flex")
  // }
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      {/* <link href="https://fonts.googleapis.com/css2?family=Cedarville+Cursive&display=swap" rel="stylesheet"></link> */}
      <div style={{ width: theme.SCALES.navigationWidth, height: "100%" }}>
        <QFNavigation
          client_name_node={client_name_node.current}
        ></QFNavigation>
      </div>
      <div
        style={{
          height: "100%",
          width: `calc(100% - ${theme.SCALES.navigationWidth} - ${theme.SCALES.qfHelpOrTipWidth})`,
          backgroundColor: theme.COLORS.tertiary_lightbackground,
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}
      >
        <CloudIcon formstate={formstate} formsorder={formsorder}></CloudIcon>

        <div style={{ width: "100%", height: "90%" }}>
          <QuestionArea></QuestionArea>
        </div>
        <div
          style={{
            width: "100%",
            height: "10%",
            // backgroundColor: theme.COLORS.help_tip,
          }}
        >
          <QuestionNavigationButtons
            setopenModal={setopenModal}
          ></QuestionNavigationButtons>
        </div>
      </div>
      <div style={{ width: theme.SCALES.qfHelpOrTipWidth, height: "100%" }}>
        <VerticalHelpOrTip prospectId={prospectId}></VerticalHelpOrTip>
      </div>
      <ChsModal prospectid={prospectId} />
      <BMSClientModal />

      <ChsSignoffModal
        openModal={openModal}
        openCHSconfirmationModalFun={openCHSconfirmationModalFun}
        cbArr={cbArr}
        iconArr={iconArr}
        updateCBArr={updateCBArr}
        updateIconArr={updateIconArr}
        creditQDis={creditQDis}
        showThankyouPage={showThankyouPage}
        submitConsentForClient={submitConsentForClient}
        disableSbmtBtn={disableSbmtBtn}
        onSignatureChange={onSignatureChange}
        prospectid={prospectId}
      />
      <GtmModal prospectId={prospectId} />
    </div>
  );
};

const BMSClientModal = () => {
  const dispatch = useDispatch();
  const existingBMSPayload = useSelector(getBMSPayload);
  let existingCustomers =
    existingBMSPayload?.data?.ConfuseSituation?.Clients || [];
  let [openModalState, setopenModalState] = useState(
    existingCustomers.length > 0
  );
  let [clientCode, setClientCode] = useState("");
  let [customLookUpCode, setcustomLookUpCode] = useState(false);
  useEffect(() => {
    setopenModalState(existingCustomers.length > 0);
    //console.log("updateBMSSuccess: ", existingBMSPayload);
    if (
      existingBMSPayload.error &&
      existingBMSPayload.msg &&
      !existingBMSPayload.data
    ) {
      toast.error(existingBMSPayload.msg);
    }
  }, [existingBMSPayload]);
  const useStyles = makeStyles({
    input: {
      color: "white", // White input text
    },
    placeholder: {
      "&::placeholder": {
        color: "rgba(255, 255, 255, 0.7)", // White placeholder text
        opacity: 1, // Ensures visibility
      },
    },
    outlinedInput: {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "white", // White border
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "lightgray", // Light gray on hover
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "white", // White when focused
      },
    },
  });
  const classes = useStyles();
  return (
    <>
      <CommonModal
        modalHeight={"60vh"}
        modalWidth={"55vw"}
        openModalBool={openModalState}
        closeModal={() => {
          setopenModalState(false);
        }}
        handleSbmtBtn={() => {
          dispatch(
            updateBmsInfo({ action: "create_client", postdata: { clientCode } })
          );
          setopenModalState(false);
        }}
        style={{ overflow: "hidden" }}
        buttontxt="Confirm"
        heading="Existing Customer(s) Found"
        innerOverflow="auto"
      >
        <p style={{ fontSize: "medium", padding: "3px" }}>
          There are possible matches for this client in your BMS. If this is an
          existing client, we will update the existing client file in your BMS.
          Please select the appropriate client. If this is a new client to your
          brokerage, then please click on the "New client" button and Quotey
          will create a new client file in your BMS.
        </p>
        <RadioGroup
          onChange={(e) => {
            console.log(e.target.value);
            if ("customer_lookup_code" == e.target.value) {
              setcustomLookUpCode(false);
            } else {
              setcustomLookUpCode(true);
              setClientCode(e.target.value);
            }
          }}
        >
          <FormControlLabel
            value="force_creation"
            control={<Radio />}
            label="New Customer"
          />
          <FormControlLabel
            value="no_creation"
            control={<Radio />}
            label="No Integration - Already in Epic"
          />
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <FormControlLabel
              value="customer_lookup_code"
              control={<Radio />}
              label="Customer Lookup Code"
            />
            <TextField
              variant="outlined"
              size="small"
              placeholder="Enter lookup code"
              InputProps={{
                classes: {
                  input: classes.input,
                  root: classes.outlinedInput,
                },
                className: classes.placeholder, // Ensures placeholder styling
              }}
              onChange={(e) => {
                console.log(e.target.value);
                setClientCode(e.target.value);
              }}
              disabled={customLookUpCode}
            />
          </div>

          {existingCustomers.map((existingCustomer) => (
            <FormControlLabel
              value={existingCustomer.ClientLookUpCode}
              control={<Radio />}
              label={`${existingCustomer.ClientLookUpCode} ${existingCustomer.Name} ${existingCustomer.Address1}`}
            />
          ))}
        </RadioGroup>
      </CommonModal>
    </>
  );
};

const ClientHandOffModal = () => {
  const headingSize = "20%";
  const chs_ = useSelector(getCHS);
  const formstate = useSelector(getFormState);
  const formsorder = useSelector(getFormsOrder);
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;

  const prospectid = useSelector(getProspectIdFromQF);
  var [chs, setchs] = useState(chs_);
  var groupList = Object.values(formstate)
    .filter((t) => !t.questionid)
    .map((x) => {
      return {
        name: languagepreference === "en" ? x.text.en : x.text.fr,
        id: x.id,
      };
    });
  var [showList, setshowList] = useState([]);
  const [isExpressApp, setExpressApp] = useState(false);
  const dispatch = useDispatch();
  const handleCheck = (e) => {
    var name = e.target.getAttribute("info");
    var sort = e.target.getAttribute("sort");
    if (e.target.checked) {
      setshowList([...showList, { name, sort }]);
    } else {
      var deleted = showList.filter((x) => x.name != name);
      setshowList([...deleted]);
    }
  };
  const handleExpressAppCheck = (e) => {
    setExpressApp(e.target.checked);
  };
  useEffect(() => {
    var sortedList = showList.sort((a, b) => a.sort - b.sort);
    var urlStringJoin = sortedList.map((x) => x.name).join(",");
    setchs(
      chs_ +
        "&show=" +
        encodeURIComponent(urlStringJoin) +
        "&isExpressApp=" +
        isExpressApp
    );
  }, [showList, isExpressApp]);
  useEffect(() => {
    const onKeyPressed = (e) => {
      if (e.keyCode === 27) {
        dispatch(clientHandOffModalClosed());
      }
    };
    document.addEventListener("keydown", onKeyPressed);

    return () => {
      document.removeEventListener("keydown", onKeyPressed);
    };
  }, [dispatch]);

  let divHeights = {
    heading: "15%",
    tableAddItem: "",
    lastButtons: "1%",
  };
  divHeights.tableAddItem = `calc(100% - ${divHeights.heading} - ${divHeights.lastButtons})`;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "48.34vh",
      }}
    >
      {" "}
      <div style={{ position: "absolute", top: 10, right: 10 }}>
        <CancelIcon
          fontSize="large"
          style={{ cursor: "pointer", color: "white" }}
          onClick={() => {
            dispatch(clientHandOffModalClosed());
            setTimeout(() => {
              dispatch(
                setautoreminder({
                  text:  translations[languagepreference].followUpText ,
                  title: translations[languagepreference].followUpTitle ,
                  prospectid,
                  remindercategory: "Chase hand-off",
                })
              );
            }, 500);
          }}
        ></CancelIcon>
      </div>
      <div
        style={{
          width: "100%",
          height: headingSize,
          color: "white",
          fontSize: "2.8vmin",
          padding: "2vh",
          fontFamily: "GibsonSemiBd",
          letterSpacing: 1,
        }}
      >
        {translations[languagepreference].handOffToClient}
      </div>
      <div style={{ color: "white", marginLeft: "3vw" }}>
        {translations[languagepreference].optionsToInclude}
        {groupList.map((x, idx) => (
          <div style={{ marginLeft: "2vw" }}>
            <input
              type="checkbox"
              id={`checkbox_${x.id}`}
              sort={idx}
              info={x.id}
              onClick={handleCheck}
            ></input>
            <label for={`checkbox_${x.id}`} style={{ marginLeft: "1vw" }}>
              {" "}
              {x.name}{" "}
            </label>
          </div>
        ))}
        <div style={{ marginLeft: "2vw" }}>
          <input
            type="checkbox"
            id={`checkbox_isExpressApp`}
            info={`isExpressApp`}
            onClick={handleExpressAppCheck}
          ></input>
          <label for={`checkbox_isExpressApp`} style={{ marginLeft: "1vw" }}>
            {" "}
            {"Turbo App "}
          </label>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          height: `calc(100% - ${headingSize})`,
          color: "white",
          fontSize: "2.8vmin",
          padding: "2vh",
          fontFamily: "GibsonSemiBd",
          letterSpacing: 1,
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
            height: "50%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ width: "80%" }}>
            <LinkSelect text={chs} iconcolor={"white"} chs={true}></LinkSelect>
          </div>
        </div>

        <div
          style={{
            width: "100%",
            height: "50%",
            color: "white",
            display: "flex",
            alignItems: "start",
            justifyContent: "center",
            fontFamily: "GibsonSemiBd",
            fontSize: "1.9vmin",
            textAlign: "center",
          }}
        >
          {translations[languagepreference].pleaseShareWithClient}
        </div>
      </div>
    </div>
  );
};

const CloudIcon = ({ formstate, formsorder }) => {
  const dispatch = useDispatch();

  const isProspectUpdating = useSelector(getIsProspectUpdating);
  const isProspectSucceed = useSelector(getIsProspectSucceed);
  const brokerage_info = useSelector(getBrokerageInformation);
  // checks who is the current user (broker or client of broker)
  const qfUserMode = useSelector(getQFuserMode);

  useEffect(() => {
    if (qfUserMode === CLIENT)
      dispatch(updateProspectFormsForClient({ updateFromState: true }));
    if (qfUserMode === BROKER)
      dispatch(updateProspectForms({ updateFromState: true }));
  }, [formstate, dispatch, qfUserMode]);

  useEffect(() => {
    //brokerage_info?.otherinfo?.bms?.workflow?.[0]
    const [createClientinBMS] = brokerage_info?.otherinfo?.bms?.workflow || [];
    if (qfUserMode === BROKER && createClientinBMS) {
      dispatch(updateBmsInfo({ action: "create_client" }));
    }

    //console.log(formstate)
  }, [formstate, dispatch, qfUserMode]);

  useEffect(() => {
    //brokerage_info?.otherinfo?.bms?.workflow?.[0]
    const [createClientinBMS] = brokerage_info?.otherinfo?.bms?.workflow || [];
    if (qfUserMode === BROKER && createClientinBMS) {
      dispatch(updateBmsInfo({ action: "create_client" }));
    }
  }, [formstate, dispatch, qfUserMode]);

  useEffect(() => {
    // setting sessionStorage with existing answers
    for (var keyFormstate in formstate) {
      for (var keyNodestate in formstate[keyFormstate]?.nodestate) {
        var node = formstate[keyFormstate].nodestate[keyNodestate];
        if (node?.answer) {
          var storeAnswer =
            typeof node.answer === "string" || node.answer instanceof String
              ? node.answer
              : JSON.stringify(node.answer);
          sessionStorage.setItem(node.id, storeAnswer);
        }
      }
    }
  }, []);

  useEffect(() => {
    if (qfUserMode === CLIENT)
      dispatch(updateProspectFormsForClient({ updateFormsOrder: true }));
    if (qfUserMode === BROKER)
      dispatch(updateProspectForms({ updateFormsOrder: true }));
  }, [formsorder, dispatch, qfUserMode]);

  return (
    <div
      style={{
        position: "absolute",
        right: 0,
        height: 50,
        width: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {isProspectUpdating ? (
        <Spinner animation="border" size="sm" variant="success" />
      ) : (
        <div>
          {isProspectSucceed ? (
            <CloudDoneIcon
              style={{
                color: theme.COLORS.dark_green_dot,
                fontSize: theme.SCALES.cloudIconSize,
              }}
            ></CloudDoneIcon>
          ) : (
            <div></div>
          )}
        </div>
      )}
    </div>
  );
};

const QuestionNavigationButtons = (props) => {
  const dispatch = useDispatch();
  const formsorder = useSelector(getFormsOrder);
  const formstate = useSelector(getFormState);
  const currentnodeformid = useSelector(getCurrentNodeFormId);
  const currentnode = useSelector(getCurrentNode);
  const prospectId = useSelector(getProspectIdFromQF);
  const qfUserMode = useSelector(getQFuserMode);
  const clientLog = useSelector(getClientLog);
  const gotProspectDetails = useSelector(getProspectDoc);
  const userInformation = useSelector(getBrokerInformation);
  const languagepreference = userInformation?.information?.languagepreference || "en";
  const navigate = useNavigate();
  const setopenModal = props.setopenModal;
  const isLastForm = ({ formsorder, currentnodeformid }) => {
    try {
      return formsorder[formsorder.length - 1] === currentnodeformid;
    } catch (e) {
      return false;
    }
  };
  const isFirstForm = ({ formsorder, currentnodeformid }) => {
    try {
      // console.log("This is it", formsorder[0] === currentnodeformid.formid);

      return formsorder[0] === currentnodeformid;
    } catch (e) {
      return false;
    }
  };

  const handlePrevious = () => {
    dispatch(currentNodeChangeOnPreviousClick());
    // make the form tab visible
    // FormRefs[currentnode.formid].scrollIntoView();
  };

  const handleNext = () => {
    dispatch(currentNodeChangeOnNextClick());
    // make the form tab visible
    //FormRefs[currentnode.formid].scrollIntoView();
  };

  //#region Commenting this out for now as next arrow and left arrow makes can be required while
  //        answering questions
  // useEffect(() => {
  //   const onKeyPressed = (e) => {
  //     // right key
  //     if (e.keyCode === 39) {
  //       handleNext();
  //     }
  //     // left key
  //     if (e.keyCode === 37) {
  //       handlePrevious();
  //     }
  //   };
  //   document.addEventListener("keydown", onKeyPressed);

  //   return () => {
  //     document.removeEventListener("keydown", onKeyPressed);
  //   };
  // }, []);
  //#endregion

  const isParentOfNodeOfForm = ({ formstate, currentnode, first = false }) => {
    try {
      let { formtype, formid } = currentnode;
      let cFormstate = formstate[formid]; // getting current formstate

      let parentProperties = first
        ? FormProperties({
            formtype,
          }).getParentUniquePropertiesOfFirstNode({ formstate: cFormstate })
        : FormProperties({
            formtype,
          }).getLastParentUniquePropertiesOfLastNode({ formstate: cFormstate });

      let resultantBoolean = true;
      if (parentProperties) {
        for (let property in parentProperties) {
          if (parentProperties[property] !== currentnode[property]) {
            resultantBoolean = false;
          }
        }
      }

      return resultantBoolean;
    } catch (e) {
      return false;
    }
  };

  const isLastNodeParent = ({
    formstate,
    formsorder,
    currentnode,
    currentnodeformid,
  }) => {
    if (isLastForm({ formsorder, currentnodeformid })) {
      return isParentOfNodeOfForm({ formstate, currentnode });
    }
    return false;
  };

  const isFirstNodeParent = ({
    formstate,
    formsorder,
    currentnode,
    currentnodeformid,
  }) => {
    if (isFirstForm({ formsorder, currentnodeformid })) {
      return isParentOfNodeOfForm({ formstate, currentnode, first: true });
    }
    return false;
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingLeft: theme.SCALES.letfRighMarginInQuestionArea,
        paddingRight: theme.SCALES.letfRighMarginInQuestionArea,
      }}
    >
      {isFirstNodeParent({
        formstate,
        currentnode,
        formsorder,
        currentnodeformid,
      }) ? (
        <div></div>
      ) : (
        <NavigationButton
          text={translations[languagepreference].previous}
          bgColor={theme.COLORS.back_button_color}
          onClick={handlePrevious}
        ></NavigationButton>
      )}
      {isLastNodeParent({
        formstate,
        currentnode,
        formsorder,
        currentnodeformid,
      }) ? (
        qfUserMode === CLIENT ? (
          <NavigationButton
            bgColor={theme.COLORS.secondary_skyblue}
            width={"25%"}
            disabled={!clientLog || clientLog?.length == 0}
            text={translations[languagepreference].imDoneAnswering}
            onClick={async () => {
              //document.location.href = `/quotes?id=${prospectId}`;
              if (!clientLog || clientLog?.length == 0) {
                console.log("No changes made");
                return;
              }
              var reminder_data = {
                title: "Client finished Answering",
                description: "Please review client changes",
                ownertype: "individual",
                owner: gotProspectDetails.userid,
                remindertype: "prospect",
                clientid: null,
                policyid: null,
                prospectid: gotProspectDetails._id,
                remindercategory: "cat-2",
                reminderdate: new Date().toJSON(),
                archive: false,
                deleted: false,
                brokeragecode: gotProspectDetails.brokeragecode,
                //"sendemail": true
              };

              let transaction_data = {
                prospectid: gotProspectDetails._id,
                oldstatus: "Client adjustments",
                newstatus: "Client adjustments",
                comment: "Please review client changes during client hand-off",

                otherDetails: { clientLog: clientLog },
                usertime: new Date(),
              };
              await dispatch(
                submitChangesForClient({ transaction_data, reminder_data })
              );
              //setopenModal(true)
              dispatch(openCHSconfirmationModalFun(true));
              //history.push( `/thanksforanswers`);
            }}
          ></NavigationButton>
        ) : (
          <NavigationButton
            bgColor={theme.COLORS.secondary_skyblue}
            width={"25%"}
            text={translations[languagepreference].goToMarket}
            onClick={() => {
              //navigate(`/quotes?id=${prospectId}`)
              dispatch(goToMarket());
              //document.location.href = `/quotes?id=${prospectId}`;
            }}
          ></NavigationButton>
        )
      ) : (
        <NavigationButton
          bgColor={theme.COLORS.secondary_skyblue}
          text={translations[languagepreference].next}
          onClick={handleNext}
        ></NavigationButton>
      )}
    </div>
  );
};

const NavigationButton = ({
  onClick,
  text,
  bgColor,
  width = "15%",
  disabled,
}) => {
  const bkgColor = bgColor ? bgColor : "lightgray";
  disabled = disabled ? disabled : false;
  return (
    <Button
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      style={{
        color: "white",
        fontFamily: "GibsonSemiBd",
        fontSize: "1.5vmin",
        backgroundColor: bkgColor,
        width: width,
        borderRadius: "5%",
        height: "50%",
        letterSpacing: 1,
      }}
    >
      {text}
    </Button>
  );
};

export default QFMainPane;
